// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/GeneralSeating/GeneralSeating.css
// module id = 1167
// module chunks = 0